import React from "react";
import MarkdownToJSX from "markdown-to-jsx";

export function Markdown(props: { children: string }) {
  return <MarkdownToJSX>{props.children}</MarkdownToJSX>;
}
